<template>
  <div class="reg-banner">
    <img
      v-if="!get_partnerBanners.is_default_banner && srcBanner"
      :src="srcBanner"
      alt="registration banner partner"
      class="reg-banner__partner"
    />
    <div v-else class="reg-banner__default">
      <div class="reg-banner__text">
        <UiText
          font="banner-kicker"
          color="banner-mobile-kicker-color"
          :text="$tc('navigation.welcomePackText')"
        />
        <UiText
          font="banner-heading"
          bold
          color="banner-mobile-heading-color"
          :text="$tc('navigation.welcomePackGift')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RegAuthForgotBannersMobile',
  computed: {
    ...mapGetters('promotions', ['get_partnerBanners']),
    srcBanner() {
      const serverSrc = this.get_partnerBanners.banners?.banner_mobile

      return serverSrc ? this.$config.cloudUrl + serverSrc : null
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
